// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core from "@material-ui/core";

function CircularLoader(Props) {
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("div", {
              className: className,
              style: {
                marginTop: "10rem",
                marginLeft: "50%"
              }
            }, React.createElement(Core.CircularProgress, {}));
}

var make = CircularLoader;

export {
  make ,
  
}
/* react Not a pure module */
